export default "__VITE_ASSET__86b7a1cf__"